import React, { ReactNode } from "react";
import { AlertDialog, Button, HStack, View } from "native-base";
import { translate } from "../locales/translate";
import { ArButton } from "../argon-ui";
import { getDir } from "../util";
interface PropsType {
  title?: string;
  children: ReactNode;
  isOpen: boolean;
  confirmText?: any;
  cancelText?: string | null | undefined;
  cancelBtn?: boolean;
  cancelVariant?: string | null | undefined;
  colorConfirm?: string | null | undefined;
  confirmHandler?: () => void;
  onClose: () => void;
}
const AlertDialogBase = (props: PropsType) => {
  const {
    children,
    title,
    isOpen,
    confirmText,
    cancelText,
    cancelBtn = true,
    colorConfirm,
    cancelVariant,
    confirmHandler,
    onClose,
  } = props;
  const onCloseHandler = () => onClose();
  const cancelRef = React.useRef(null);
  const ref = React.useRef();
  const cmpRef = ref.current && ref.current.children[0];
  const onConfirmHandler = () => {
    confirmHandler && confirmHandler();
    onClose();
  };
  return (
    <AlertDialog
      closeOnOverlayClick={false}
      isKeyboardDismissable={false}
      leastDestructiveRef={cancelRef}
      ref={cmpRef}
      isOpen={isOpen}
      onClose={onCloseHandler}
      style={{ direction: getDir() }}
    >
      <AlertDialog.Content>
        {/* === Header === */}
        <HStack
          flexDirection="row-reverse"
          justifyContent="space-between"
          mb="10px"
        >
          <AlertDialog.CloseButton
            mx="20px"
            position="relative"
            style={{
              height: 35,
              width: 35,
              justifyContent: "center",
              alignItems: "center",
            }}
          />
          <AlertDialog.Header borderBottomWidth={0} mt="5px">
            {title}
          </AlertDialog.Header>
        </HStack>
        {/* === Body === */}
        {children && (
          <AlertDialog.Body>
            {/*  A text node cannot be a child of a <View>  */}
            <View>{children}</View>
          </AlertDialog.Body>
        )}
        {/* === Footer === */}
        <AlertDialog.Footer
          borderTopWidth={0}
          justifyContent="flex-start"
          flexDirection="row"
        >
          <Button.Group space={3} flexDirection="row-reverse" w="full">
            {cancelBtn && (
              <ArButton
                style={{ marginBottom: 0, flex: 1 }}
                variant={cancelVariant || "outline"}
                color="muted"
                onPress={onCloseHandler}
                // ref={cancelRef}
              >
                {cancelText || translate("app.cancel")}
              </ArButton>
            )}
            {(confirmText || confirmHandler) && (
              <ArButton
                style={{ flex: 1, marginBottom: 0 }}
                color={colorConfirm || "error"}
                onPress={() => onConfirmHandler()}
              >
                {confirmText}
              </ArButton>
            )}
          </Button.Group>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialog>
  );
};

export default AlertDialogBase;
